<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="refresh"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.charger_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>

      <!--<template slot="menu" slot-scope="scope">
        <el-button type="text" size="small" @click.native="tip(scope.row.id)">自定义按钮</el-button>
      </template>-->

      <!--<template slot="onlineStatus"  slot-scope="scope" >
        <span v-if="scope.row.onlineStatus == 'ON'">在线</span>
        <span v-if="scope.row.onlineStatus == 'OFF'">不在线</span>
      </template>-->

      <!--<template slot="qrCode" slot-scope="scope">
        <qrcode  :value="scope.row.id" :options="{ size: 100 }"></qrcode>

      </template>-->
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, getDetail, add, update, remove } from '@/api/v4ward/charger/charger';
import { mapGetters } from 'vuex';
// import QRCode from 'qrcode';
//import Qrcode from '@xkeshi/vue-qrcode'

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        index: true,
        indexLabel: '序号',
        height: 'auto',
        calcHeight: 50,
        tip: false,
        border: true,
        viewBtn: true,
        selection: true,
        menuType: 'text',
        column: [
          {
            label: '编号',
            prop: 'id',
            addDisplay: false,
            editDisplay: false,
            rules: [
              {
                required: true,
                message: '请输入主键/充电桩编号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: 'Sim卡号',
            prop: 'simCardNumber',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入Sim卡号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '设备ID',
            prop: 'deviceId',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入设备ID',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '租户名称',
            prop: 'tenantName',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入租户名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '小区ID',
            prop: 'communityId',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入小区ID',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '小区名称',
            prop: 'communityName',
            rules: [
              {
                required: true,
                message: '请输入小区名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '充值地址',
            prop: 'originUrl',
            // type: "img",
            addDisplay: false,
            editDisplay: false,
            rules: [
              {
                required: true,
                message: '充值二维码',
                trigger: 'blur',
              },
            ],
          },
          /*{
              label: "充值二维码",
              prop: "qrCode",
              // type: "img",
              addDisplay: false,
              editDisplay:false,
              rules: [{
                required: true,
                message: "充值二维码",
                trigger: "blur",
                slot: true
              }]
            },*/
          {
            label: '别名/备注',
            prop: 'chargerName',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入别名/备注',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '分配时间',
            prop: 'allocatedTime',
            hide: true,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请输入分配时间',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '上线状态',
            prop: 'onlineStatus',
            addDisplay: false,
            editDisplay: false,
            /*rules: [{
                trigger: "blur",
                slot: true
              }]*/
          },
          {
            label: '最新动态',
            prop: 'recentDynamicState',
            addDisplay: false,
            editDisplay: false,
          },
        ],
      },
      data: [],
    };
  },
  /*components:{
      "qrcode": Qrcode
    },*/
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.charger_add, false),
        viewBtn: this.vaildData(this.permission.charger_view, false),
        delBtn: this.vaildData(this.permission.charger_delete, false),
        editBtn: this.vaildData(this.permission.charger_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then((res) => {
          this.form = res.data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    refresh() {
      this.onLoad(this.page);
    },
    tip(param) {
      this.$message.success('自定义按钮 ' + param);
    },
  },
};
</script>

<style>
.el-table .cell {
  white-space: pre-line;
}
</style>
